import styled from "styled-components";
import { tokens, palette } from "@plataforma/components";

export const Avatar = styled.figure`
  margin: 0;
  padding: 0;

  width: 44px;
  height: 44px;
  line-height: 44px;
  border-radius: 22px;
  flex-shrink: 1;

  background-color: ${palette.primaryLight};

  text-align: center;
  text-transform: uppercase;
  color: ${palette['color-brand-primary']};
  font-size: 19px;
  font-weight: ${tokens.font.weight.semibold};

  overflow: hidden;
`;